export type BlogPostMeta = {
  slug: string;
  title: string;
  excerpt: string;
  /** Optional small brand/logo shown on index + post header */
  logoSrc?: string;
  logoAlt?: string;
  /** Optional "case study" label */
  brand?: string;
  /** Optional publish date label (display-only) */
  dateLabel?: string;
};

export const BLOG_POSTS: BlogPostMeta[] = [
  {
    slug: 'no-frills',
    title: 'The Human MOAT: A Masterclass in Employee Generated Content (EGC)',
    excerpt:
      "In an era of AI-generated content and declining trust, Joe & Val's No Frills built a \"Human Moat\" by empowering employees as brand protagonists \u2014 driving 70M+ views and an \"Alive Store Effect.\"",
    logoSrc: '/logos/no-frills.svg',
    logoAlt: 'No Frills',
    brand: 'No Frills',
    dateLabel: '2026',
  },
  {
    slug: 'philz-coffee',
    title: "Why Philz Coffee Doesn't Need a \"Viral\" Strategy",
    excerpt:
      'In the coffee sector, "The Vibe" is the primary currency. But in 2026, a vibe curated by a corporate marketing team feels like a stage set - pretty, but hollow.',
    logoSrc: '/logos/philz-coffee.svg',
    logoAlt: 'Philz Coffee',
    brand: 'Philz Coffee',
    dateLabel: '2026',
  },
  {
    slug: 'papajohns',
    title: "The New Owned Media: How Papa John's Built a 350M+ View Content Engine Through Employees",
    excerpt:
      "In 2025 alone, two Papa John's employees generated over 350 million organic views \u2014 with zero ad spend and zero production budget. This is the playbook for building a defensible, employee-powered content engine.",
    logoSrc: '/logos/papajohns.svg',
    logoAlt: "Papa John's",
    brand: "Papa John's",
    dateLabel: '2026',
  },
];
